var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSettings = function SvgSettings(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    stroke: "currentColor",
    strokeWidth: 1.7,
    transform: "translate(1 1)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 9,
    cy: 9,
    r: 2.739
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18 10.291v-2.68l-1.565-.114a1.66 1.66 0 0 1-1.417-1.025v-.02a1.67 1.67 0 0 1 .278-1.729l1.025-1.174-1.905-1.91-1.174 1.026a1.67 1.67 0 0 1-1.73.278h-.02c-.58-.23-.977-.771-1.025-1.393L10.338 0h-2.68l-.114 1.542A1.65 1.65 0 0 1 6.52 2.947a1.67 1.67 0 0 1-1.73-.278L3.617 1.643l-1.93 1.879 1.026 1.174c.412.477.52 1.147.278 1.73a1.66 1.66 0 0 1-1.425 1.071L0 7.611v2.68l1.565.118a1.66 1.66 0 0 1 1.417 1.025v.02a1.67 1.67 0 0 1-.278 1.729l-1.025 1.174 1.894 1.894 1.174-1.025a1.67 1.67 0 0 1 1.73-.278h.019c.585.25.981.808 1.025 1.444L7.658 18h2.68l.114-1.585a1.68 1.68 0 0 1 1.025-1.428h.02a1.67 1.67 0 0 1 1.73.274l1.173 1.021 1.894-1.898-1.025-1.174a1.67 1.67 0 0 1-.278-1.73v-.019a1.66 1.66 0 0 1 1.444-1.052z"
  }))));
};
export default SvgSettings;